import { Component, OnInit, AfterViewInit, ViewChild  } from '@angular/core';
import { ReportService } from '../services/report.service';
import { Revenue } from '../data/revenue';
import { FuncsService } from '../services/funcs.service';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';

@Component({
    selector: 'app-report-tiers',
    templateUrl: './report-tiers.component.html',
    styleUrls: ['./report-tiers.component.css'],
    standalone: false
})
export class ReportTiersComponent implements OnInit, AfterViewInit {
  public loading = "Loading...";
  report: Revenue[] = [];

  displayedColumns: string[] = ['date', 'revenue'];

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  dataSource = new MatTableDataSource<Revenue>(this.report);

  constructor(
    private reportService: ReportService,
    private funcs: FuncsService
  ) {}

  ngOnInit(): void {
    this.funcs.checkAdmin();
    
    this.reportService.getDealerTiers().subscribe(report => {
      this.report = report;
      this.dataSource.data = this.report;
      this.loading = "";
    });
  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }
}
